var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 17","width":"140"}},[_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 9h58v8H0V9z","fill":"#0f69c4"}}),_c('path',{attrs:{"d":"M58 9h82v8H58V9z","fill":"#e22c2c"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }